import { render, staticRenderFns } from "./email-dialog-new.vue?vue&type=template&id=47986bbf&scoped=true"
import script from "./email-dialog-new.vue?vue&type=script&lang=ts"
export * from "./email-dialog-new.vue?vue&type=script&lang=ts"
import style0 from "./email-dialog-new.vue?vue&type=style&index=0&id=47986bbf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47986bbf",
  null
  
)

export default component.exports